'use client';

import type { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { SiteShell } from './SiteShell';

// Wraps root-layout {children} with the full SiteShell (nav, footer,
// BackgroundProvider, cursor effects, etc.) EXCEPT on scene-only
// surfaces like /pond-v3 where we want the page to render its own
// scene in isolation. /koi-debug stays inside SiteShell because it's
// a debug surface for v2 specifically — BackgroundProvider also
// mounts the v2 pond there, which is what /koi-debug is debugging.
//
// /pond-v3 is different: it mounts PondSceneV3 itself, doesn't need
// the v2 scene from BackgroundProvider, and shouldn't render the
// site nav over its own scene. Bypassing SiteShell here also avoids
// the dual-WebGL-renderer cost.

const SCENE_ONLY_PATHS = ['/pond-v3', '/koi-debug-mesh'];

export function ConditionalShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const sceneOnly = pathname ? SCENE_ONLY_PATHS.some((p) => pathname.startsWith(p)) : false;
  if (sceneOnly) {
    return <>{children}</>;
  }
  return <SiteShell>{children}</SiteShell>;
}
